// Module
var code = "<div class=\"scroll-view\" :style=\"{ overflow: 'auto', maxHeight: maxHeight + 'px', maxWidth: maxWidth + 'px' }\"> <slot></slot> </div> ";
// Exports
export default code;